<template >
  <div>
<!--    <div class="crumbs">-->
<!--      <el-breadcrumb separator="/">-->
<!--        <el-breadcrumb-item>巡检任务分配</el-breadcrumb-item>-->
<!--      </el-breadcrumb>-->
<!--    </div>-->
<el-card>
      <div class="container1" style="margin-top: 20px">
        <span>规划选择:
          <el-select placeholder="规划选择" v-model="zhouqi" @change="getCyclePoint,getPlanTimeId" size="small">
            <el-option
              v-for="item in CycleTitle"
              :label="item.planTitle"
              :value="item.planningId"
            >
            </el-option>
          </el-select>
        </span>
        <span style="margin-left: 20px">规划编号:
        <el-input style="width: 180px" v-model="planTimeId" disabled size="small"></el-input>
      </span>
        <span v-model="startTime">开始时间:{{startTime}}</span>
        <span v-model="endTime">结束时间:{{endTime}}</span>
        <div style="height: 20px"></div>
        <span>巡检结束时间:
            <el-date-picker
              v-model="shijian"
              type="date"
              placeholder="选择时间"
              format="yyyy 年 MM 月 dd 日"
              value-format="yyyy-MM-dd"
              size="small"
            >
            </el-date-picker>
          </span>
        <span>巡检人员选择:
            <el-select placeholder="巡检人员选择" v-model="renyuan" clearable size="small">
              <el-option
                v-for="item in UserList"
                :label="item.name"
                :value="item._id"
              ></el-option>
            </el-select>
          </span>
        <span>
              <el-button type="primary" @click="distributionDevice" size="small" style="border-radius: 5px">分配</el-button>
            </span>
      </div>
      <div style="height: 20px"></div>
      <div style="margin: 0 0 40px 0">
        <span style="margin-right: 30px">
            <el-button type="primary" @click="getCyclePoint1(1)" size="small">查看已分配设备</el-button>
            <el-dialog title="设备列表" :visible.sync="dialogDeviceVisible" v-if="dialogDeviceVisible" @close="getCyclePoint">
              <span>人员选择:
            <el-select placeholder="人员选择" v-model="renyuan1" clearable>
              <el-option
                v-for="item in UserList"
                :label="item.name"
                :value="item.name"
              ></el-option>
            </el-select>
                <el-button type="primary" @click="getCyclePoint1(2)" style="margin-left: 30px">查询</el-button>
          </span>
                <el-table :data="CyclePoint1">
                  <el-table-column property="pointName" label="设备名称" width="200"></el-table-column>
                  <el-table-column property="alarmPointType" label="设备类型"></el-table-column>
                  <el-table-column property="assignorName" label="巡检人"></el-table-column>
                  <el-table-column v-if="false" property="alarmPointId" label="设备Id"></el-table-column>
                  <el-table-column label="操作">
                    <template slot-scope="scope">
                      <span style="color: #1f53c1;cursor:pointer;text-decoration:underline" @click="cancelInspectTask(scope.row)">取消分配</span>
<!--                        <el-button type="primary" size="mini" @click="cancelInspectTask(scope.row)">取消</el-button>-->
                    </template>
                  </el-table-column>
                </el-table>
              <div class="pagination">
                <el-pagination
                  @current-change="getCyclePoint1(1)"
                  background
                  layout="prev, pager, next"
                  :page-size="10"
                  :total="totalCount1*10"
                  :current-page.sync="GetCyclePointInfo1.params.pageNumber">
                </el-pagination>
              </div>
            </el-dialog>
          </span>
        <span>
            <el-button type="info" @click="dialogPersonVisible = true" size="small">人员分配调整</el-button>
            <el-dialog title="人员分配调整" :visible.sync="dialogPersonVisible" v-if="dialogPersonVisible">
              <span>原巡检人员:<el-select v-model="userBefore" @change="getCyclePoint2">
                <el-option
                  v-for="item in UserList"
                  :label="item.name"
                  :value="item.name"
                ></el-option>
              </el-select></span>
              <span style="margin-left: 20px">现巡检人员:<el-select v-model="userNew">
                <el-option
                  v-for="item in UserList"
                  :label="item.name"
                  :value="item._id"
                ></el-option>
              </el-select></span>

              <div style="margin-top: 20px">
                <span>巡检结束时间:
            <el-date-picker
              v-model="shijian1"
              type="date"
              placeholder="选择时间"
              format="yyyy 年 MM 月 dd 日"
              value-format="yyyy-MM-dd"
              style="width: 200px"
            >
            </el-date-picker>
          </span>
                <el-button type="primary" style="margin-left: 20px" @click="distributionDevice1">保存</el-button>
                <el-button type="primary" style="margin-left: 20px">取消</el-button>
              </div>

              <div>
                <el-table
                  ref="deviceAdjustment"
                  :data="CyclePoint2"
                  style="width:100%"
                  tooltip-effect="dark"
                  class="AdjustmentTable"
                >
                   <el-table-column
                     type="selection"
                     width="55"
                   >
                    </el-table-column>
                  <el-table-column
                    prop="_id"
                    label="设备id"
                    v-if="false"
                  ></el-table-column>
                    <el-table-column
                      prop="pointName"
                      label="设备名称"
                      show-overflow-tooltip
                    ></el-table-column>
                </el-table>
              </div>

            </el-dialog>
          </span>
        <span style="margin-left: 20px">
          <el-button type="info" @click="exportExcel" size="small">报表导出</el-button>
        </span>
      </div>
    <div class="container2">
      <span>设备名称:
          <el-input v-model="deviceName" placeholder="设备名称"clearable style="width: 150px" size="small"></el-input>
      </span>
      <span>区域:
        <el-cascader placeholder="请选择区域" multiple v-model="GetCyclePointInfo.params.areaId"
        :options="AreaList.result.areaList" clearable size="small" :props="{ checkStrictly: true }"
        >

        </el-cascader>
      </span>
      <span>是否分配:
          <el-select placeholder="是否分配" clearable v-model="IsAssign" size="small">
            <el-option
              v-for="item in isAssign"
              :key="item"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
        </span>
      <!--        <span>是否巡检:-->
      <!--          <el-select placeholder="是否巡检" clearable v-model="IsInspect">-->
      <!--            <el-option-->
      <!--              v-for="item in isInspect"-->
      <!--              :key="item"-->
      <!--              :label="item"-->
      <!--              :value="item"-->
      <!--            ></el-option>-->
      <!--          </el-select>-->
      <!--        </span>-->
      <span>
          <el-button type="primary" @click="searchPointList" size="small">查询</el-button>
          <el-button type="info" @click="resetPointList" size="small">重置</el-button>
        </span>
<!--      <span>设备类型:-->
<!--        <el-select placeholder="设备类型" clearable v-model="deviceType">-->
<!--          <el-option-->
<!--            v-for="item in TypeList"-->
<!--            :label="item"-->
<!--            :value="item"-->
<!--          ></el-option>-->
<!--        </el-select>-->
<!--      </span>-->

      </div>
    <div class="container4">
        <el-table
          ref="multipleTable"
          :data="this.CyclePoint"
          style="width:100%;overflow-y: scroll;"
          tooltip-effect="dark"
          :default-sort="{prop:'isDistribution', order:'descending'}"
          id="out-table"
        >
          <el-table-column
            type="selection"
            show-overflow-tooltip
          >
          </el-table-column>

          <el-table-column
            prop="pointName"
            label="设备名称"
            show-overflow-tooltip
            align="center"
          ></el-table-column>
          <el-table-column
            prop="areaName"
            label="区域"
            show-overflow-tooltip
            align="center"
          ></el-table-column>
          <el-table-column
            prop="alarmPointType"
            label="设备类型"
            show-overflow-tooltip
            align="center"
          ></el-table-column>
          <el-table-column
            prop="isDistribution"
            label="分配与否"
            sortable
            show-overflow-tooltip
            align="center"
          ></el-table-column>
          <el-table-column
            prop="assignorName"
            label="被分配人"
            show-overflow-tooltip
            align="center"
          ></el-table-column>
          <el-table-column
            prop="inspectId"
            label="巡检与否"
            show-overflow-tooltip
            align="center"
          ></el-table-column>
          <el-table-column
            prop="_id"
            label="设备id"
            v-if="false"
          ></el-table-column>
        </el-table>
        <div class="pagination">
          <el-pagination
            @current-change="getCyclePoint"
            background
            layout="prev, pager, next"
            :page-size="10"
            :total="totalCount*10"
            :current-page.sync="GetCyclePointInfo.params.pageNumber">
          </el-pagination>
        </div>

    </div>
</el-card>
  </div>

</template>

<script>
  import FileSaver from "file-saver"
  import XLSX from "xlsx"
    export default {
        name: "inspectTaskAssignment",
        data(){
          return{
            //data:'',//穿梭框左侧数据
            //value:'',//穿梭框右侧数据
            userBefore:'',//原维修人员
            userNew:'',//现维修人员
            planTimeId:'',//规划编号ID
            tableHeight:260,
            currentPage:1,
            currentPage1:1,
            totalCount:'',//表格总数据数
            totalCount1:'',//分配列表表格总数据数
            dialogDeviceVisible:false,//查看人员设备分配情况Dialog框的状态
            dialogPersonVisible:false,//人员分配调整Dialog框
            zhouqi:'',
            planTime:'',
            startTime:'',
            shijian:'',
            shijian1:'',
            endTime:'',
            renyuan:'',
            renyuan1:'',
            deviceID:'',
            deviceName:'',
            deviceType:'',
            IsAssign:'',
            IsInspect:'',
            isAssign:['未分配','已分配'],
            isInspect:[],
            multipleVal:[],
            GetCycleTitleInfo:{//发送获取规划主题下拉框请求
              "version":1,
              "method":"distribution.GetPlanningTitle",
              "params":null,
              "token":"#",
              "id":0
            },
            CycleTitle:[
              {
                "planningId":'',
                "planTitle":''
              }
            ],
            GetPlanTime:{//获取规划编号
              "version":1,
              "method":"planning.GetPlanningInfo",
              "params":{
                "pageNumber":1,
                "planningId":''
              },
              "token":"#",
              "id":0
            },
            GetUserInfoList:{//获取人员列表
              "version": 1,
              "method": "user.GetUserList",
              "params": {
                "username":"",
                "name":"",
                "role":""
              },
              "token": "",
              "id": 0
            },
            UserList:[
              {
                "_id":'',
                "username":'',
                "password":'',
                "name":'',
                "role":'',
                "phoneNumber":'',
                "deletedFlag":'',
                "userType":'',
                "token":'',
                "areaId":'',
                "areaName":''
              }
            ],//人员列表
            GetAreaInfoList:{//获取区域列表
             "version":1,
             "method":"area.GetAreaList",
              "params":null,
              "token":"#",
              "id":0
            },
            AreaList:{//区域列表
              "version": 1,
              "result":{
                "areaList": [
                  {
                    "areaId": "",
                    "label": "",
                    "childList":[],
                  },
                ]
              },
              "id": 0
            },
            AlarmPointTypeList:[],
            GetCyclePointInfo:{//获取表格数据
              "version":1,
              "method":"planning.GetPlanPoints",
              "params":{
                "pageNumber":1,
                "planningId":'',
                "pointName":'',
                "alarmPointType":'',
                "assignorName":'',
                "areaId":'',
              },
              "token":"#",
              "id":0
            },
            CyclePoint:[
              {
                //planningId:"",
                _id:"",
                pointName:"",
                alarmPointType:"",
                //areaId:"",
                areaName:"",
                //assignorId:"",
                assignorName:"",
                //asOfTime:"",
                isDistribution:"",
                //confirmTime:"",
                inspectId:""
              }
            ],
            GetCyclePointInfo1:{//获取表格数据(用于“查看已分配设备界面”)
              "version":1,
              "method":"planning.GetPlanPoints",
              "params":{
                "pageNumber":1,
                "planningId":'',
                "pointName":'',
                "alarmPointType":'',
                "assignorName":'',
                "areaId":'',
                "confirm":''
              },
              "token":"#",
              "id":0
            },
            CyclePoint1:[
              {
                //planningId:"",
                planPointId:"",
                pointName:"",
                alarmPointType:"",
                //areaId:"",
                //areaName:"",
                //assignorId:"",
                assignorName:"",
                //asOfTime:"",
                //confirm:"",
                //confirmTime:"",
                //inspectId:""
              }
            ],
            GetCyclePointInfo2:{//获取表格数据(用于“人员分配调整界面(原分配人员)”)
              "version":1,
              "method":"planning.GetPlanPoints",
              "params":{
                "pageNumber":1,
                "planningId":'',
                "pointName":'',
                "alarmPointType":'',
                "assignorName":'',
                "areaId":'',
                "confirm":''
              },
              "token":"#",
              "id":0
            },
            CyclePoint2:[{
              _id:"",
              pointName:""
            }],
            GetCyclePointInfo3:{//获取表格数据(用于“人员分配调整界面(现分配人员)”)
              "version":1,
              "method":"planning.GetPlanPoints",
              "params":{
                "pageNumber":1,
                "planningId":'',
                "pointName":'',
                "alarmPointType":'',
                "assignorName":'',
                "areaId":'',
                "confirm":''
              },
              "token":"#",
              "id":0
            },
            CyclePoint3:[],
            TypeList:[
              '电声警报器','电动警报器','多媒体','一体机','其他'
            ],//设备类型列表
            distribution:{
              "version":1,
              "method":"distribution.AddInsperctionTaskes",
              "params":{
                "planningId":'',
                "asOfTime":'',
                "assignorId":'',
                "assignorName":'',
                "managementId":'',
                "planningPointList":[]
              },
              "token":"#",
              "id":0
            },
            cancelInspect:{
              "version":1,
              "method":"distribution.CancelInsperctionTaskes",
              "params":{
                "planningId":'',
                "planningPointList":[]
              },
              "token":"#",
              "id":0
            }

          }
        },
        methods:{

          getCycleTitle(){//获取巡检规划表中的规划主题
            this.GetCycleTitleInfo.token = this.$store.state.token;
            this.$axios.post(this.$mainUrl,this.GetCycleTitleInfo).then(res=>{
              if(res.data.hasOwnProperty('result')) {
                this.CycleTitle = res.data.result.planTitleList
                this.zhouqi = res.data.result.planTitleList[0].planningId;
                this.getCyclePoint();
                // this.getCycleTime();

              }
            })
          },
          getPlanTimeId(){//根据规划主题获取规划编号
            let string ='';
            this.GetPlanTime.params.planningId = this.zhouqi;
            for(let key in this.GetPlanTime.params){
              if(this.GetPlanTime.params[key] === ""){
                this.GetPlanTime.params[key] = null;
              }
            };
            this.$axios.post(this.$mainUrl,this.GetPlanTime).then(res=>{
              if(res.data.hasOwnProperty('result')){
                string = res.data.result.planningList[0].planTimeId;
                this.planTimeId = string;
                this.startTime = res.data.result.planningList[0].startTime;
                this.endTime = res.data.result.planningList[0].endTime;
              }
            })
          },
          // getCycleTime(){//获取巡检规划对应的时间
          //     this.GetPlanTime.params.planningId= this.zhouqi;
          //     this.$axios.post(this.$mainUrl,this.GetPlanTime).then(res=>{
          //       if(res.data.hasOwnProperty('result')){
          //
          //       }
          //     })
          // },
          getUserList(){//获取人员列表
            for(let key in this.GetUserInfoList.params){
              if(this.GetUserInfoList.params[key] === ""){
                this.GetUserInfoList.params[key] = null;
              }
            }
            this.GetUserInfoList.token = this.$store.state.token;
            this.$axios.post(this.$mainUrl,this.GetUserInfoList).then(res =>{
              if(res.data.hasOwnProperty('result')){
                  this.UserList = res.data.result.userList;
              }
            })
          },
          getAreaList(){//获取区域列表
            this.GetAreaInfoList.token = this.$store.state.token;
            this.$axios.post(this.$mainUrl,this.GetAreaInfoList).then(res =>{
              if(res.data.hasOwnProperty('result')){
                let areaList = JSON.stringify(res.data);
                areaList  = areaList.replace(/childList/g, 'children');
                areaList  = areaList.replace(/areaName/g, 'label');
                areaList  = areaList.replace(/areaId/g, 'value');
                areaList = JSON.parse(areaList);
                this.AreaList = areaList;
              }
            })
          },
          getCyclePoint(){//获取表格数据
            // this.getCycleTime();
            let newArray = [];
            let newArray1 = [];
            let newArray2 = [];
            for (let val in this.GetCyclePointInfo.params){
              if(this.GetCyclePointInfo.params[val] === ""){
                this.GetCyclePointInfo.params[val] = null;
              }
            }
            this.GetCyclePointInfo.token = this.$store.state.token;
            this.GetCyclePointInfo.params.planningId = this.zhouqi;
            this.$axios.post(this.$mainUrl,this.GetCyclePointInfo).then(res=>{
              if(res.data.hasOwnProperty('result')){
                this.CyclePoint = res.data.result.planningPointList;
                for(let i=0;i<res.data.result.planningPointList.length;i++){
                  if(res.data.result.planningPointList[i].assignorName != ""){
                    this.CyclePoint[i].isDistribution = '已分配'
                  }else{
                    this.CyclePoint[i].isDistribution = '未分配'
                  }if(res.data.result.planningPointList[i].inspectId ==''||res.data.result.planningPointList[i].inspectId ==null){
                    res.data.result.planningPointList[i].inspectId = '未巡检'
                  }else{
                    res.data.result.planningPointList[i].inspectId = "已巡检"
                  }
                   newArray[i] = res.data.result.planningPointList[i].inspectId;
                  for (let i = 0; i < newArray.length; i++) {
                    if (newArray1 .indexOf(newArray[i]) === -1) {
                      newArray1 .push(newArray[i]);
                    }
                  }
                  this.isInspect = newArray1;
                }
                this.totalCount = res.data.result.page;
              }
            })

          },
          getCyclePoint1(val){//查看已分配设备中获取表格数据
            if(this.zhouqi === ''){
              alert("请先选择巡检周期")
              this.CyclePoint1='';
            }else{
              this.dialogDeviceVisible=true
              for (let val in this.GetCyclePointInfo1.params){
                if(this.GetCyclePointInfo1.params[val] === ""){
                  this.GetCyclePointInfo1.params[val] = null;
                }
              }
              this.GetCyclePointInfo1.token = this.$store.state.token;
              if(this.renyuan1==''||this.renyuan1 == null){
                this.GetCyclePointInfo1.params.assignorName = 'false';
              }
              else {
                this.GetCyclePointInfo1.params.assignorName = this.renyuan1;
              }
              this.GetCyclePointInfo1.params.planningId = this.zhouqi
              if(val == 2){
                this.GetCyclePointInfo1.params.pageNumber = 1;
              }
              this.$axios.post(this.$mainUrl,this.GetCyclePointInfo1).then(res=>{
                if(res.data.hasOwnProperty('result')){
                  this.CyclePoint1 = res.data.result.planningPointList;
                  this.totalCount1 = res.data.result.page;
                }
              })
            }


          },
          cancelInspectTask(val){
            this.cancelInspect.params.planningPointList=[];
            this.cancelInspect.params.planningId = this.zhouqi;
            this.cancelInspect.params.planningPointList.push(val.alarmPointId);
            this.$confirm("是否确认取消巡检任务？",{
                      confirmButtonText:'确定',
                      cancelButtonText:'取消',
                      type:'warning'
                    }).then(()=>{
                      this.$axios.post(this.$mainUrl,this.cancelInspect).then(res=>{
                        if(res.data.hasOwnProperty('result')){
                          this.CyclePoint1 = [];
                          this.getCyclePoint1(1)
                        }
                      })
                    }).catch(()=>{
                      this.$message({
                        type:'info',
                        message:'已取消'
                      })
                    })

          },
          getCyclePoint2(){//人员分配调整中获取表格数据
            let newArray=[];
            if(this.zhouqi === ''){
              alert("请先选择巡检周期")
            }else{
              for (let val in this.GetCyclePointInfo2.params){
                if(this.GetCyclePointInfo2.params[val] === ""){
                  this.GetCyclePointInfo2.params[val] = null;
                }
              }
              this.GetCyclePointInfo2.token = this.$store.state.token;
              this.GetCyclePointInfo2.params.assignorName = this.userBefore;
              this.GetCyclePointInfo2.params.planningId = this.zhouqi
              this.$axios.post(this.$mainUrl,this.GetCyclePointInfo2).then(res=>{
                if(res.data.hasOwnProperty('result')){
                  this.CyclePoint2 = res.data.result.planningPointList;
                }
              })
            }


          },

          searchPointList(){//根据查询条件搜索对应的设备
            this.GetCyclePointInfo.params.planningId = this.zhouqi;
            this.GetCyclePointInfo.params.pointName = this.deviceName;
            this.GetCyclePointInfo.params.alarmPointType = this.deviceType;
            this.GetCyclePointInfo.params.pageNumber = 1;
            if(this.GetCyclePointInfo.params.areaId !== null) {
              this.GetCyclePointInfo.params.areaId = this.GetCyclePointInfo.params.areaId[this.GetCyclePointInfo.params.areaId.length - 1];
            }
            if(this.IsAssign === '已分配'){
              this.GetCyclePointInfo.params.isDistribution = '已分配';
            }else if(this.IsAssign === '未分配'){
              this.GetCyclePointInfo.params.isDistribution = '未分配';
            }
            for (let val in this.GetCyclePointInfo.params){
              if(this.GetCyclePointInfo.params[val] === ""){
                this.GetCyclePointInfo.params[val] = null;
              }
            }
            this.$axios.post(this.$mainUrl,this.GetCyclePointInfo).then(res=>{
              if(res.data.hasOwnProperty('result')){
                this.CyclePoint = res.data.result.planningPointList;
                for(let i=0;i<res.data.result.planningPointList.length;i++){
                  if(res.data.result.planningPointList[i].assignorName != ""){
                    this.CyclePoint[i].isDistribution = '已分配'
                  }else{
                    this.CyclePoint[i].isDistribution = '未分配'
                  }
                  if(res.data.result.planningPointList[i].inspectId !=""){
                    res.data.result.planningPointList[i].inspectId ='已巡检'
                  }else {
                    res.data.result.planningPointList[i].inspectId ='未巡检'
                  }
                }
                this.totalCount = res.data.result.page;
              }
            })
          },
          resetPointList(){//重置查询
            this.deviceName = '';
            this.deviceType = '';
            this.GetCyclePointInfo.params.areaId = '';
            this.isAssign='';
            this.isInspect = '';
            this.getCycleTitle();
          },

          distributionDevice(){//设备分配
            let newArray = [];
            let newArray1 = [];
            for(let i=0;i<this.$refs.multipleTable.selection.length;i++){
              newArray1[i] = this.$refs.multipleTable.selection[i].isDistribution;
            };
            if(this.renyuan === ''){
              alert('请先选择被分配人员！')
            }
            else if(newArray1.indexOf('已分配') !=-1){
              alert("选择的设备中存在已分配设备，请重新选择!")
            }
            else if (this.shijian === ''){
              alert('请选择巡检结束时间')
            }
            else if(this.$refs.multipleTable.selection.length ===0){
              alert("请选择设备！")
            }
              else{
              for (let val in this.distribution.params){
                if(this.distribution.params[val] === ""){
                  this.distribution.params[val] = null;
                }
              }
                for(let i=0;i<this.$refs.multipleTable.selection.length;i++){
                  newArray[i] = JSON.stringify(this.$refs.multipleTable.selection[i]._id).replace("\"", "").replace("\"", "");
                }
                this.distribution.params.planningPointList = newArray;
                this.distribution.params.planningId = this.zhouqi;
                this.distribution.params.asOfTime = this.shijian;
                this.distribution.params.assignorId = this.renyuan;
                //this.distribution.params.managementId = 'admin';

                this.$axios.post(this.$mainUrl,this.distribution).then(res=>{
                  if(res.data.hasOwnProperty('result')){
                    this.$message({
                      type:'success',
                      message:'分配成功'
                    })
                    this.getCyclePoint();
                  }else{
                    alert(res.data.error.message.toString())
                  }
                })

              }
          },
          distributionDevice1(){//设备维修人员调整
            let newArray = [];
            if(this.userBefore ===''||this.userNew === ''){
              alert("人员不能为空")
            }else if(this.$refs.deviceAdjustment.selection.length === 0){
              alert("请至少选择一个警报点")
            }
            else{
              for(let i=0;i<this.$refs.deviceAdjustment.selection.length;i++){
                newArray[i] = JSON.stringify(this.$refs.deviceAdjustment.selection[i]._id).replace("\"", "").replace("\"", "");
              }
              this.distribution.params.planningPointList = newArray;
              this.distribution.params.planningId = this.zhouqi;
              this.distribution.params.asOfTime = this.shijian1;
              this.distribution.params.assignorId = this.userNew;
              this.distribution.params.managementId = 'admin';
              this.$axios.post(this.$mainUrl,this.distribution).then(res=>{
                if(res){
                  this.$message({
                    type:'success',
                    message:'分配成功'
                  })
                  this.getCyclePoint2()
                }
              })

            }
          },

          exportExcel(){
            /*从表生成工作簿对象*/
            let wb = XLSX.utils.table_to_book(document.querySelector("#out-table"));
            /*获取二进制字符串作为输出*/
            let wbout = XLSX.write(wb,{
              bookType:'xlsx',
              bookSST:true,
              type:"array"
            })
            try {
              FileSaver(
                //Blob 对象表示一个不可变，原始数据的类文件对象
                //Blob 表示的不一定是JavaScript原生格式的数据
                //File 接口基于Blob，继承了blob的功能并将其扩展使其支持用户系统上的文件
                //返回一个新创建的Blob对象，其内容由参数中给定的数组串联组成
                new Blob([wbout],{type:"application/octet-stream"}),
                //设置导出文件名称
                "sheetjs.xlsx"
              );
            }catch (e) {
              if(typeof console !=="undefined") console.log(e,wbout);
            }
            return wbout;
          }
        },
      mounted() {
        this.getCycleTitle();
        this.getUserList();
        this.getAreaList();
        // this.getCyclePoint();
        this.getPlanTimeId()
      }
    }
</script>

<style scoped>
  .container1{
    margin-bottom: 30px;
  }
  .container3{
    margin-top:10px;
  }
  .container1 span{
    margin: 0px 20px;
  }
  .container2 span{
    margin: 0px 20px;
  }
  .container3 span{
    margin: 0px 20px;
  }
  .container6{
    margin: 20px 0px 20px 600px
  }
  .container6 span{
    margin:20px 20px
  }
  .AdjustmentTable td{
    padding: 6px 0!important;
  }

</style>
